import indexAdmin from "@/views/indexAdmin";
import store from "@/store";
import view404 from "@/views/view404";
import localStore from "@/utils/localStore";
// Super Admin Pages
const gatewayTableSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/gatewayTableSA"
  );
const pmTabsSA = () =>
  import(/* webpackChunkName: "adminPages" */ "@/views/superadmin/pmTabs");
const pondGuardTableSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/pondGuardTableSA"
  );
const shrimpTalkTableSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/shrimpTalkTableSA"
  );
const customersView = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/customersView"
  );
const clientsViewSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/views/superadmin/clientsViewSA"
  );
const dealerTableSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/dealerTableSA"
  );

const pgListIndividualDetailsSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/pgListIndividualDetailsSA"
  );
const gatewayListIndividualDetailsSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/gatewayListIndividualDetailsSA"
  );
const pmListIndividualDetailsSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/pmListIndividualDetailsSA"
  );
const stListIndividualDetailsSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/stListIndividualDetailsSA"
  );
const customerListIndividualDetailsSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/customerListIndividualDetailsSA"
  );
const clientsIndividualViewSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/views/superadmin/clientsIndividualViewSA"
  );
const DealerDetailsTable = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/DealerDetailsTable"
  );
const accountManagerIndividualViewSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/accountManagerIndividualViewSA"
  );

const accountManagerTableSA = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/superadmin/accountManagerTableSA"
  );
export const userProfile = () =>
  import(
    /* webpackChunkName: "userProfile" */ "@/components/settings/userProfile"
  );

const signout = () => {
  store.dispatch("auth/superAdminSignOut").catch((err) => {
    console.error(err);
    throw err;
  });
};
const defaultPagesBasedOnUserType = (userType, next) => {
  switch (userType) {
    case userTypes.super_admin:
      return "/admin/customers";
    default:
      signout();
      return "/sign-in";
  }
};
const doesUserCanAccess = function(to, from, next) {
  try {
    const currUserType = localStore.getItem("curr-user-type");
    if (!currUserType) {
      signout();
      return next("/sign-in");
    }
    const pageAllowedUserType = to.meta.userTypeAllowed;
    if (pageAllowedUserType.indexOf(currUserType) === -1) {
      return next(defaultPagesBasedOnUserType(currUserType, next));
    }
    return next();
  } catch (err) {
    console.error(
      "Check the flow logic and user permissions of the router",
      err
    );
  }
};
const userTypes = {
  admin: "ADMIN",
  pond_owner: "POND_OWNER",
  pond_worker: "POND_WORKER",
  pond_technician: "POND_TECHNICIAN",
  pond_manager: "POND_MANAGER",
  no_access: "NO_ACCESS",
  super_admin: "SUPER_ADMIN",
};

const allUserTypes = () => [
  userTypes.admin,
  userTypes.pond_owner,
  userTypes.pond_manager,
  userTypes.pond_worker,
  userTypes.pond_technician,
];

const comn_admin_pages_meta_data = {
  permissions: [userTypes.super_admin],
  dependOnLocations: false,
  userTypeAllowed: [userTypes.super_admin],
  isPermissionRequired: true,
};
export default {
  path: "/admin",
  component: indexAdmin,
  children: [
    {
      path: "/",
      redirect: "customers",
    },
    {
      path: "gateways",
      name: "gateways",
      component: gatewayTableSA,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Comn_gateway",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "pondmothers",
      name: "pondmothers",
      component: pmTabsSA,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Comn_pond_mother",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "pondguards",
      name: "pondguards",
      component: pondGuardTableSA,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Comn_pond_guard",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "shrimptalks",
      name: "shrimptalks",
      component: shrimpTalkTableSA,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Comn_shrimptalk",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "customers",
      name: "customers",
      component: customersView,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Customers",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "clients",
      name: "clients",
      component: clientsViewSA,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Clients",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "dealers",
      name: "dealers",
      component: dealerTableSA,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Customers",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "account",
      name: "account",
      component: accountManagerTableSA,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Account Manager",
      },
      beforeEnter: doesUserCanAccess,
    },

    {
      path: "pondmothers/:pm_id",
      name: "PondMotherDetails",
      component: pmListIndividualDetailsSA,
      props: true,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Comn_pond_mother",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "pondguards/:pg_id",
      name: "PondGuardDetails",
      component: pgListIndividualDetailsSA,
      props: true,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Comn_pond_guard",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "gateways/:gateway_id",
      name: "GatewayDetails",
      component: gatewayListIndividualDetailsSA,
      props: true,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Comn_gateway",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "customers/:customer_id",
      name: "CustomerDetails",
      component: customerListIndividualDetailsSA,
      props: true,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Customers",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "clients/:client_id",
      name: "clientDetails",
      component: clientsIndividualViewSA,
      props: true,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Clients List",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "accountmanager/:accountmanager_id",
      name: "accountmanagerdetails",
      component: accountManagerIndividualViewSA,
      props: true,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Account Managers List",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "dealer/:dealer_id",
      name: "dealerDetails",
      component: DealerDetailsTable,
      props: true,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "dealers List",
      },
      beforeEnter: doesUserCanAccess,
    },

    {
      path: "shrimptalks/:st_id",
      name: "ShrimpTalkDetails",
      component: stListIndividualDetailsSA,
      props: true,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Comn_shrimptalk",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "profile",
      name: "profile",
      component: userProfile,
      meta: {
        ...comn_admin_pages_meta_data,
        langKey: "Profile",
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "404",
      name: "admin404",
      component: view404,
      meta: {
        langKey: "PondLogs",
      },
      // prop: true
    },
  ],
};
